<template>
  <NotificationTemplate
    :notification="notification"
    :projectName="sprintContent.projectName"
  >
    <template #pic>
      <div class="label-pic is-blue">
        <icon
          data="@icon/list-unordered-v2.svg"
          class="label-pic__icon"
          width="var(--icon-24)"
          height="var(--icon-24)"
          color="#1565C0"
        />
      </div>
    </template>
    <template #title>
      <BaseSubHeading
        v-if="sprintContent?.reminder"
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        Sprint is ending in a few days. Please complete your Sprint Retrospective.
      </BaseSubHeading>
      <BaseSubHeading
        v-else
        size="large"
        color="monochrome-06"
        darkColor="monochrome-03"
        weight="500"
      >
        You've been invited to participate in Sprint #{{ sprintContent.sprint.sequenceNumber }}
        Retrospective
      </BaseSubHeading>
    </template>
    <template #content>
      <ul>
        <li class="notification__todo">
          <BaseSubHeading
            size="medium"
            color="monochrome-06"
            darkColor="monochrome-03"
            weight="400"
          >
            <a
              class="link is-medium"
              target="_blank"
              :href="sprintContent.retrospectiveUrl"
            >
              {{ sprintContent.todoName }}
            </a>
          </BaseSubHeading>
          <icon
            data="@icon/flag.svg"
            :fill="true"
            width="14"
            height="14"
            class="notification__todo-icon"
            color="#D32F2F"
          />
        </li>
      </ul>
    </template>
  </NotificationTemplate>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"

import NotificationTemplate from "@/components/Notification/NotificationTemplate.vue"

import { NotificationRetrospective } from "@/models"

@Options({
  name: "SPRINT_RETROSPECTIVE_TODO",
  components: {
    NotificationTemplate
  }
})
export default class SPRINT_RETROSPECTIVE_TODO extends Vue {
  @Prop() readonly notification: NotificationRetrospective

  get sprintContent() {
    return this.notification.content
  }
}
</script>
